import { buildCommonInsuranceContractParameters } from '../buildCommonInsuranceContractParameters'

export const contractSaveParametersGeneration = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  return buildCommonInsuranceContractParameters({
    type,
    contractId,
    contactId,
    addressId,
    contractData,
    characteristicsData,
    contactPreferences,
    action,
  })
}
